import { Spinner } from "react-bootstrap";

const Loading = () => {
    return (
        <div className="d-flex align-items-center justify-content-center vh-100">
            <Spinner
                variant="info"
                color="primary"
                style={{
                    height: '4rem',
                    width: '4rem'
                }}
                type="grow"
            />
        </div>
    );
}

export default Loading;